import { useTranslation } from 'react-i18next';

import { Button, SingleLineText, Title, LogoutButton, WithErrorBoundary } from '@bloomays-lib/ui.shared';
import RawPeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { styled } from '@mui/material/styles';
import { useAuthStore } from '../../stores';
import { Logger } from '../../services/serviceLogger';

const logger = Logger('TooManyAccounts');

const BLOOMHELP_URL = 'https://bit.ly/bloomays-help';

const TooManyAccounts = () => {
  const { t } = useTranslation(['firstCo']);
  const auth = useAuthStore((state) => state.auth);
  logger.info(`${auth?.user?.email} has too many bloomer accounts`, { user: auth?.user });
  return (
    <ContainerDiv>
      <Title textTitle={t('tooManyAccountsTitle')} />
      <PeopleOutlineIcon />
      <SingleLineText text={t('tooManyAccounts')} />
      <SingleLineText text={t('tooManyAccountsContact')} />
      <ContainerActions>
        <Button textButton={t('tooManyAccountsHelpButton')} onClick={() => window.open(BLOOMHELP_URL, '_blank')} />
        {/* margin:0 : neutralise le margin auto du LogoutButton qui écarte les boutons du conteneur flex */}
        <LogoutButton
          logout={() => auth?.logout()}
          textButton={t('tooManyAccountsReconnect')}
          type="button"
          style={{ margin: 0 }}
        />
      </ContainerActions>
    </ContainerDiv>
  );
};

export default WithErrorBoundary(TooManyAccounts);

const ContainerDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  backgroundColor: theme.palette.neutral.white,
  boxShadow: `2px 2px 20px ${theme.palette.neutral[10]}`,
  borderRadius: '10px',
  width: '40%',
  margin: '1em auto',
  padding: '1em',
  [theme.breakpoints.down('md')]: {
    width: '85%',
  },
}));

const PeopleOutlineIcon = styled(RawPeopleOutlineIcon)(({ theme }) => ({
  color: theme.palette.blue[60],
  fontSize: '130px !important',
  margin: 'auto',
}));

const ContainerActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '20px',
  marginTop: '2em',
  [theme.breakpoints.down('md')]: {
    flexFlow: 'column nowrap',
    gap: '10px',
  },
}));
